import { useChatUnreadCount } from '@gastfreund/roq-ui-react';
import React, { FC, PropsWithChildren } from 'react';

import NotificationsBadge from '../../components/MUI/NotificationsBadge';

type Props = {
  className?: string;
};

/**
 * Chat notification badge
 *
 * @param props           Props passed to the component
 * @param props.children  Children passed to the component
 * @param props.className Class passed down by styled components
 * @returns               The component itself
 */
export const ChatBubble: FC<PropsWithChildren<Props>> = props => {
  const unreadCount = useChatUnreadCount();

  return <NotificationsBadge badgeContent={unreadCount} {...props} />;
};
